/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entrylinklabel2Inputs */

const en_entrylinklabel2 = /** @type {(inputs: Entrylinklabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link`)
};

const de_entrylinklabel2 = /** @type {(inputs: Entrylinklabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link`)
};

/**
* | output |
* | --- |
* | "Link" |
*
* @param {Entrylinklabel2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entrylinklabel2 = /** @type {((inputs?: Entrylinklabel2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entrylinklabel2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entrylinklabel2(inputs)
	return de_entrylinklabel2(inputs)
});
export { entrylinklabel2 as "entryLinkLabel" }